export const Feedback = () => (
    <div className="sds_full-screen-feedback">
        <iframe
            title="Product Feedback"
            id="typeform-full"
            width="100%"
            height="100%"
            src="https://freemarkethealth.typeform.com/to/cO7s1rRG"
        />
    </div>
);
